(function($){
    $('.news-list').each(function(){
        if ($(this).hasClass("carousel")){
            var elementColumn = this.getAttribute("slick-columns");
            var scrollOptions = JSON.parse(this.getAttribute("scroll-options"));
            var cssid = $(this).parent().attr('id');
            $(this).slick(optionConstructor(elementColumn, scrollOptions, `.news-list-section#${cssid} > .next`, `.news-list-section#${cssid} > .previous`));
        }
    });
})(jQuery);